<template>
  <div class="odp_mod_line">
    <div class="odp_mod_li_name font-14">{{ lineData["name"] }}：</div>
    <div class="odp_mod_li_right font-14">
      <template v-for="(item, index) in lineData['data']">
        <!-- 下拉块 -->
        <div
          v-if="item.type === 'select'"
          :class="{ odp_mod_li_rig_select: true }"
          :key="item.id"
          :data-index="index"
          @mouseenter="func_vData_selectEnter"
          @mouseleave="func_vData_selectLeave"
          @click="func_vData_selectEnter"
        >
          <div
            :class="{
              odp_mod_li_rig_sel_content: true,
              odp_mod_li_rig_isChoose: item.choose,
            }"
            data-type="data"
            :data-index="lineIndex"
            :data-seq="index"
            @click="func_vData_select_click"
          >
            <div class="odp_mod_li_rig_sel_con_name">{{ item.name }}</div>
            <img
              :class="{
                odp_mod_li_rig_sel_con_icon: true,
                odp_mod_li_rig_sel_con_icon_rotate: item.select_show,
              }"
              src="@/assets/icon/arrow_down.png"
            />
          </div>
          <div class="odp_mod_li_rig_list">
            <template v-for="(obj, seq) in item.select_data">
              <div
                :class="{
                  odp_mod_li_rig_li_view: true,
                  odp_mod_li_rig_li_view_show: item.select_show,
                }"
                :key="obj.id"
                data-type="data"
                :data-index="lineIndex"
                :data-seq="index"
                :data-select_index="seq"
                @click.stop="func_vData_select_click"
              >
                {{ obj.name }}
              </div>
            </template>
          </div>
        </div>
        <!-- :class="{'odp_mod_li_rig_view_h5':true,
        'odp_mod_li_rig_isChoose_h5':item.choose}" @click='func_click' -->
        <!-- <div
          class="odp_mod_li_rig_isChoose_h5"
          v-if="item.type === 'select'"
          :key="item.id"
          data-type="data"
          :data-index="lineIndex"
          :data-seq="index"
        >
          <template v-for="(obj, seq) in item.select_data">
            <div
              :class="{
                odp_mod_li_rig_li_view_show: true,
                odp_mod_li_rig_li_view_show_h5: obj.choose,
              }"
              :key="obj.id"
              data-type="data"
              :data-index="lineIndex"
              :data-seq="index"
              :data-select_index="seq"
              @click="func_vData_select_click_h5"
            >
              {{ obj.name }}
            </div>
          </template>
        </div> -->
        <!-- 普通块 -->
        <div
          v-else-if="item.type === 'default'"
          :class="{
            odp_mod_li_rig_view: true,
            odp_mod_li_rig_isChoose: item.choose,
          }"
          :key="item.id"
          data-type="data"
          :data-index="lineIndex"
          :data-seq="index"
          @click="func_click"
        >
          {{ item.name }}
        </div>
        <!-- 自定义输入块-1个 -->
        <div
          v-else-if="item.type === 'custom1'"
          :class="{
            odp_mod_li_rig_custom: true,
            odp_mod_li_rig_isChoose: item.choose,
          }"
          :key="item.id"
          data-type="data"
          :data-index="lineIndex"
          :data-seq="index"
          @click="func_click"
        >
          <div class="odp_mod_li_rig_cust_name">
            {{ item.name ? item.name : "自定义" }}
          </div>
          <input
            v-if="item.choose"
            class="odp_mod_li_rig_cust_input"
            style="margin-bottom: 0"
            v-model="item.value"
            @blur="func_input"
          />
          <div v-if="item.unit" class="odp_mod_li_rig_cust_unit">
            {{ item.unit }}
          </div>
        </div>
        <!-- 自定义输入块-2个 -->
        <div
          v-else-if="item.type === 'custom2'"
          :class="{
            odp_mod_li_rig_custom: true,
            odp_mod_li_rig_isChoose: item.choose,
          }"
          :key="item.id"
          data-type="data"
          :data-index="lineIndex"
          :data-seq="index"
          @click="func_click"
        >
          <div class="odp_mod_li_rig_cust_name">
            {{ item.name ? item.name : "自定义" }}
          </div>
          <template v-if="item.choose">
            <input
              class="odp_mod_li_rig_cust_input"
              style="margin-bottom: 0"
              v-model="item.value[0]"
              @blur="func_input"
            />
            <div>*</div>
            <input
              class="odp_mod_li_rig_cust_input"
              style="margin-bottom: 0"
              v-model="item.value[1]"
              @blur="func_input"
            />
            <div>mm</div>
          </template>
        </div>
        <!-- 自定义输入块-3个 -->
        <div
          v-else-if="item.type === 'custom3'"
          :class="{
            odp_mod_li_rig_custom: true,
            odp_mod_li_rig_isChoose: item.choose,
          }"
          :key="item.id"
          data-type="data"
          :data-index="lineIndex"
          :data-seq="index"
          @click="func_click"
        >
          <div class="odp_mod_li_rig_cust_name">
            {{ item.name ? item.name : "自定义" }}
          </div>
          <template v-if="item.choose">
            <span style="margin-left: 10px">高</span>
            <input
              class="odp_mod_li_rig_cust_input"
              style="margin-bottom: 0"
              v-model="item.value[0]"
              @blur="func_input"
            />
            <div>*</div>
            <span style="margin-left: 2px">宽</span>
            <input
              class="odp_mod_li_rig_cust_input"
              style="margin-bottom: 0"
              v-model="item.value[1]"
              @blur="func_input"
            />
            <div>mm</div>
            <!-- <div>*</div>
					<span style='margin-left:2px;'>起墙</span>
					<input class='odp_mod_li_rig_cust_input' style='margin-bottom:0;' v-model='item.value[2]' @blur='func_input' /> -->
          </template>
        </div>
        <!-- 自定义输入块-textarea -->
        <div
          v-else-if="item.type === 'customT'"
          :class="{
            odp_mod_li_rig_customT: true,
            odp_mod_li_rig_isChoose: item.choose,
          }"
          :key="item.id"
          data-type="data"
          :data-index="lineIndex"
          :data-seq="index"
          @click="func_click"
        >
          <div class="odp_mod_li_rig_cust_name">
            {{ item.name ? item.name : "自定义" }}
          </div>
          <textarea
            v-if="item.choose"
            class="odp_mod_li_rig_cust_textarea"
            style="margin-bottom: 0"
            v-model="item.value"
            @blur="func_input"
          ></textarea>
          <div v-if="item.unit" class="odp_mod_li_rig_cust_unit">
            {{ item.unit }}
          </div>
        </div>
        <div
          v-else-if="item.type === 'custom4'"
          :class="{
            odp_mod_li_rig_custom: true,
            odp_mod_li_rig_isChoose: item.choose,
          }"
          :key="item.id"
          data-type="data"
          :data-index="lineIndex"
          :data-seq="index"
          @click="func_click"
        >
          <div class="odp_mod_li_rig_cust_name">
            {{ item.name ? item.name : "成品尺寸长" }}
          </div>
          <template v-if="item.choose">
            <input
              class="odp_mod_li_rig_cust_input"
              style="margin-bottom: 0"
              v-model="item.value[0]"
              @blur="func_input"
            />
            <div>*{{ item.name1 ? item.name1 : "侧宽" }}</div>
            <input
              class="odp_mod_li_rig_cust_input"
              style="margin-bottom: 0"
              v-model="item.value[1]"
              @blur="func_input"
            />
            <div>*{{ item.name2 ? item.name2 : "高" }}</div>
            <input
              class="odp_mod_li_rig_cust_input"
              style="margin-bottom: 0"
              v-model="item.value[2]"
              @blur="func_input"
            />
            <div>mm</div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: "vData",
  props: {
    lineIndex: String,
    lineData: Object,
    func_click: Function,
    func_input: Function,
  },
  data() {
    return {};
  },
  methods: {
    func_vData_selectEnter() {
      const index = event.currentTarget.dataset.index;
      this.lineData["data"][index]["select_show"] = true;
    },
    func_vData_selectLeave() {
      const index = event.currentTarget.dataset.index;
      this.lineData["data"][index]["select_show"] = false;
    },
    // func_vData_select_click_h5(event) {
    //   const index = event.currentTarget.dataset.seq;
    //   const chicunid = event.currentTarget.dataset.select_index;
    //   for (let i in this.lineData["data"][index]["select_data"]) {
    //     if (i == chicunid) {
    //       this.lineData["data"][index]["select_data"][i].choose = true;
    //     } else {
    //       this.lineData["data"][index]["select_data"][i].choose = false;
    //     }
    //   }
    //   this.lineData["data"][index]["select_show"] = false;
    //   if (
    //     !event.currentTarget.dataset.select_index &&
    //     this.lineData["data"][index]["choose"]
    //   ) {
    //     return;
    //   }
    //   this.func_click(event);
    // },
    func_vData_select_click(event) {
      const index = event.currentTarget.dataset.seq;
      this.lineData["data"][index]["select_show"] = false;
      if (
        !event.currentTarget.dataset.select_index &&
        this.lineData["data"][index]["choose"]
      ) {
        return;
      }
      this.func_click(event);
    },
  },
  mounted() {

  },
  beforeMount(){
    for (let i in this.lineData["data"][0].select_data) {
      if (
        (this.lineData["data"][0].name == this.lineData["data"][0].select_data[
          i
        ].name)
      ) {
        this.lineData["data"][0].select_data[i].choose = true;
      }
    }
  }
};
</script>
<style src='@/style/orderProduct.css'></style>
<style src='@/style/orderProduct-h5.css'></style>



// WEBPACK FOOTER //
// src/pages/order/views/vData.vue